import { BaseModel } from 'paliari-js-utils'

const attributes = {
  id: null,
  nome: '',
  uf: '',
  codigo_ibge: '',
}

class Cidade extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
  }
}

export default Cidade
